import { NewMealInterface } from '../../../../../../shared/type/meal.type';

type SingleAssignmentPayload = {
  tenantId: number;
  courseId: number;
  when: string;
  mealId: number;
};

type MultiAssignmentPayload = {
  tenantId: number;
  courseId: number;
  when: string;
  mealIds: number[];
};

export type AssignmentPayload = SingleAssignmentPayload | MultiAssignmentPayload;

export const groupMealsByCategory = (
  assignMeals: NewMealInterface[],
  tenantId: number,
  mealPlanDate: string
): AssignmentPayload[] => {
  const grouped = assignMeals.reduce(
    (acc, meal) => {
      if (typeof meal.courseId !== 'number' || typeof meal.id !== 'number') {
        return acc;
      }

      if (!acc[meal.courseId]) {
        acc[meal.courseId] = [];
      }

      acc[meal.courseId].push(Number(meal.id));
      return acc;
    },
    {} as Record<number, number[]>
  );

  return Object.entries(grouped)
    .filter(([_, mealIds]) => mealIds.length > 0)
    .map(([courseId, mealIds]) => {
      const basePayload = {
        tenantId,
        courseId: Number(courseId),
        when: mealPlanDate
      };

      if (mealIds.length === 1) {
        return {
          ...basePayload,
          mealId: mealIds[0]
        };
      }

      return {
        ...basePayload,
        mealIds
      };
    });
};
